import { Injectable } from '@angular/core';
import { EMPTY, map, Observable } from 'rxjs';
import { switchMap, filter, interval, mapTo } from 'rxjs';

export interface IIntervalService {
  startInterval(active: Observable<boolean>, intervalMs: number): Observable<void>;
}

@Injectable({
  providedIn: 'root'
})
export class IntervalService implements IIntervalService {
  constructor() { }

  /**
   * Emits void every `intervalMs` milliseconds while `active` emits true.
   * Stops emitting when `active` emits false.
   * @param active$ Observable<boolean> - controls timer activity
   * @param intervalMs number - interval in milliseconds
   */
  startInterval(active: Observable<boolean>, intervalMs: number): Observable<void> {
    const isValidInterval =
      intervalMs !== undefined &&
      intervalMs !== null &&
      !isNaN(intervalMs) &&
      intervalMs > 0;

    if (!isValidInterval) {
      return EMPTY;
    }

    return active.pipe(
      switchMap(active =>
        active
          ? interval(intervalMs).pipe(map(() => undefined))
          : EMPTY
      )
    );
  }
}

@Injectable({
  providedIn: 'root'
})
export class NoOpIntervalService implements IIntervalService {
  startInterval(active: Observable<boolean>, intervalMs: number): Observable<void> {
    return EMPTY;
  }
}